module.exports = __webpack_public_path__ + "media/6.56abbe69.mp3";